import { FC } from "react";

import { PageAccordionSection } from "./PageAccordionSection";
import { SectionTitle } from "./SectionTitle";

import type { SectionKind } from "components/server-types";
import { PageListIcon } from "mds/icons";
import type { TopicWithPagesType } from "store/selectors";

export const TopicSection: FC<{
  topic: TopicWithPagesType;
  sectionKind?: SectionKind;
}> = ({ topic, sectionKind }) => (
  <PageAccordionSection
    pageIds={topic.pages.map((page) => page.id)}
    sectionKind={sectionKind}
    title={<SectionTitle count={topic.pages.length} icon={<PageListIcon />} title={topic.title} />}
  />
);
